<template>
  <div class="footer">

  </div><!--footer 结束-->
</template>


<script>
  export default{
    data:function () {
      return{

      }
    },
    mounted(){

    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// AccountAdminMainFooter.vue?3da410ca